module.exports = __webpack_public_path__ + "img/blueprint-background.c31f9b87.png";